import React, { Fragment, useState } from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { ICONS } from 'Components/utils/icon/icons';
import { isVideoUrl } from 'Components/frameworks/video/Video.utils';
import { Backdrop } from 'Components/frameworks/backdrop/Backdrop';
import { Icon } from 'Components/frameworks/icon/Icon';
import { Image } from 'Components/frameworks/image/Image';
import type { VideoProps } from 'Components/frameworks/video/Video';
import { Video } from 'Components/frameworks/video/Video';
import { themes } from './VideoWithFullScreen.themes';
type Props = VideoProps & {
  buttonLabel?: string;
  className?: string;
  closeLabel?: string;
  theme?: keyof typeof themes;
  thumbnail: string;
  title?: string;
};
export function VideoWithFullScreen(props: Props) {
  const {
    buttonLabel,
    className,
    closeLabel,
    ratioKey,
    theme = 'default',
    thumbnail,
    title,
    url,
  } = props;
  const [isExpanded, setExpanded] = useState(false);

  if (!isVideoUrl(url)) {
    return null;
  }

  if (!thumbnail) {
    return <Video className={className} ratioKey={ratioKey} url={url} />;
  }

  const {
    thIframe,
    thThumbnailButton,
    thThumbnailIcon,
    thThumbnailIconSize,
    thThumbnailButtonLabel,
    thVideo,
  } = themes[theme];
  return (
    <Fragment>
      <button
        className={classnames(thThumbnailButton, className)}
        onClick={() => setExpanded(!isExpanded)}
        type="button"
      >
        <span classnames={thThumbnailButtonLabel}>{buttonLabel}</span>
        <Image imageUrl={thumbnail} ratioKey={ratioKey} />
        <div className={thThumbnailIcon}>
          <Icon name={ICONS.MEDIA_VIDEO} width={thThumbnailIconSize} />
        </div>
      </button>
      {isExpanded && (
        <Backdrop
          ariaLabel={title}
          closeLabel={closeLabel}
          hasCloseButton
          onClose={() => setExpanded(!isExpanded)}
        >
          <Video className={thVideo} iFrameClassName={thIframe} ratioKey={ratioKey} url={url} />
        </Backdrop>
      )}
    </Fragment>
  );
}
